<template>
    <div class="row align-items-end">
        <div class="col-md-4 mb-1">
            <label class="form-label">Oluşturulma Tarih Aralığı</label>
            <v-date-picker v-model="date" range placeholder="Tarih Aralığı"></v-date-picker>        
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Tamamlandı</label>
            <select class="form-control" v-model="filter.IsCompleted">
                <option v-for="o in boolData" :value="o.value" :key="o.value">{{ o.text }}</option>
            </select>        
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Ödeme Başarılı</label>
            <select class="form-control" v-model="filter.IsPaymentSuccessfull">
                <option v-for="o in boolData" :value="o.value" :key="o.value">{{ o.text }}</option>
            </select>        
        </div>
        <div class="col-md-12 d-flex justify-content-end">
            <div class="mr-2">
                <button class="btn btn-secondary" v-on:click="$emit('filter',filter)">Filtrele</button>
            </div>
            <div class="mr-2">
                <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
            </div>
            <div class="">
                <button class="btn btn-success" v-on:click="$emit('download')">Excel Olarak İndir</button>
            </div>
        </div>
        
    </div>
</template>

<script>
import { UserApi } from '@/api/user'
export default {
    data(){
        return{
            filter:{
                CreateTimeStart :null,
                CreateTimeEnd :null,
                IsCompleted :null,
                IsNetsisOzelHesapKapatmaSuccessfull :null,
                IsNetsisSuccessfull :null,
                IsPaymentSuccessfull :null,
                PlasiyerId:null,
            },
            boolData:[
                {text:'Tümü',value:null},
                {text:'Evet',value:true},
                {text:'Hayır',value:false}
            ],
            salesman:[]
        }
    },
    mounted(){
    },
    methods:{
        
        clearForm(){
            this.filter.CreateTimeStart = null
            this.filter.CreateTimeEnd = null
            this.filter.IsCompleted = null
            this.filter.IsNetsisOzelHesapKapatmaSuccessfull = null
            this.filter.IsNetsisSuccessfull = null
            this.filter.IsPaymentSuccessfull = null
            this.filter.PlasiyerId = null
        }
    },
    computed:{
        date:{
            get:function(){
                return [this.filter.CreateTimeStart,this.filter.CreateTimeEnd].filter(d=>d != null)
            },
            set:function(val){
                this.filter.CreateTimeStart = val[0] || null
                this.filter.CreateTimeEnd = val[1] || null
            }
        }
    }
}
</script>

<style>

</style>